import React, { Component } from 'react'
import {
  NavBar,
  Icon,
  List,
  Accordion,
  Checkbox,
  InputItem,
  Button,
  Toast,
  Badge,
  WhiteSpace,
  WingBlank,
} from "antd-mobile";
import { createForm } from "rc-form";
import { connect } from "dva";

const CheckboxItem = Checkbox.CheckboxItem;

@connect(({ admin, app }) => ({ admin, app }))
export class AdminFuncRenew extends Component {
  state = {
    funcGidArr: [],
    checkedFuncGidArr: [],
    totalPrice: "0"
  };

  validateMonths = (rule, value, callback) => {
    if (value) {
      callback();
    } else {
      callback(new Error("请输入购买月数"));
    }
  };
  validateFgidList = (rule, value, callback) => {
    console.log(value)
    if (value) {
      if (value.length < 1) {
        callback(new Error("请选择功能组"));
      } else {
        callback();
      }
    } else {
      callback(new Error("请选择功能组"));
    }
  };
  render() {
    const { funcGroupList } = this.props.app;
    const { totalPrice } = this.state;
    const { dispatch, form } = this.props;
    const { validateFields, getFieldProps, getFieldsValue, getFieldError, setFieldsValue } = form;

    const submit = () => {
      validateFields({ force: true }, (error, value) => {
        console.log(value);
        if (!error) {
          dispatch({
            type: 'admin/renewByCurrency',
            payload: {
              targetId: this.props.match.params.id,
              ...value,
            },
          }).then(res => {
            console.log(res)
            if (res.status == 200) {
              Toast.success(res.message);
              setTimeout(() => window.history.go(-1), 1500);
            } else if (res.status == 856) {
              Toast.fail("虚拟币不足");
            } else {
              Toast.fail(res.message);
            }
          })
        }
      });
    };

    const onChange = (e, id, item) => {
      console.log(e.target.checked, id);
      let arr = this.state.funcGidArr;
      if (e.target.checked) {
        arr.push(item);
      } else {
        arr.splice(arr.map(item => item.id).indexOf(id), 1);
      }

      console.log(arr);
      this.setState({
        checkedFuncGidArr: arr,
      }, () => {
        // this.setState执行完的回调
        sumTotalPrice();
      })
      setFieldsValue({
        fgids: arr.map(item => item.id),
      });
    };
    const sumTotalPrice = () => {
      let months = form.getFieldValue('months');
      months = months ? months : 0;
      let sumTotalPrice = 0;
      this.state.checkedFuncGidArr.filter(item => {
        sumTotalPrice += item.adminAmount;
      });
      sumTotalPrice *= months
      this.setState({
        totalPrice: sumTotalPrice.toString(),
      })
    };
    return (
      <div className="adminFuncRenew">
        <NavBar
          icon={<Icon type="left" />}
          onLeftClick={() => this.props.history.goBack()}
        >
          续费
        </NavBar>
        <form>
          <div>
            <List
              renderFooter={() =>
                getFieldError("fgids") ||
                getFieldError("months")
              }
            >
              <Accordion defaultActiveKey="0">
                <Accordion.Panel
                  {...getFieldProps("fgids", {
                    rules: [
                      {
                        validator: this
                          .validateFgidList,
                      },
                    ],
                  })}
                  header={
                    <div>
                      <span className="red-star">*</span>
                      功能组：
                    </div>
                  }
                >
                  <List className="my-list">
                    {funcGroupList.map(item => (
                      <CheckboxItem
                        key={item.id}
                        onChange={e =>
                          onChange(
                            e,
                            item.id,
                            item,
                          )
                        }
                      >
                        {item.name}
                      </CheckboxItem>
                    ))}
                  </List>
                </Accordion.Panel>
              </Accordion>
              <InputItem
                {...getFieldProps("months", {
                  rules: [
                    {
                      validator: this
                        .validateMonths,
                    },
                  ],
                })}
                onBlur={sumTotalPrice}
                type="number"
                maxLength="5"
                clear
              >
                <i className="red-star">*</i>
                购买月数：
              </InputItem>
              <List.Item>
                虚拟币总数：
                <Badge text={totalPrice}
                  style={{ padding: '0 3px', backgroundColor: '#fff', color: '#108ee9', borderRadius: 2, border: '1px solid #108ee9', }} />
              </List.Item>
            </List>
            <WhiteSpace size="lg" />
            <WingBlank>
              <Button onClick={submit} type="primary">
                确定
            </Button>
              <WhiteSpace size="lg" />
              <Button onClick={() => this.props.history.goBack()}>
                返回
            </Button>
            </WingBlank>
          </div>
        </form>
      </div>
    )
  }
}

export default createForm()(AdminFuncRenew);
